import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  input: FelaCSS;
}

const styles: IStyles = {
  input: {
    minHeight: 54,
  },
};

export default styles;
